var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "button-editor" }, [
    _c("h4", [
      _vm._v(
        _vm._s(_vm.$t("whatsapp_business_api.buttonsHeading")) +
          " • " +
          _vm._s(_vm.buttonLabel)
      ),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "description" }, [
      _vm._v(_vm._s(_vm.buttonDescription)),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "buttons-list" },
      _vm._l(_vm.buttons, function (button, index) {
        return _c("div", { key: index, staticClass: "button-item-wrapper" }, [
          _vm.templateType === "LIMITED_TIME_OFFER"
            ? _c("div", { staticClass: "button-index-badge" }, [
                _c("span", [_vm._v(_vm._s(index))]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "button-item" },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    gap: "8px",
                    width: "180px",
                  },
                },
                [
                  _c(
                    "a-select",
                    {
                      staticStyle: { flex: "1" },
                      attrs: {
                        disabled:
                          _vm.isButtonTypeDisabled ||
                          _vm.isCopyCodeButton(button) ||
                          _vm.isRequiredUrlButton(button),
                      },
                      model: {
                        value: button.type,
                        callback: function ($$v) {
                          _vm.$set(button, "type", $$v)
                        },
                        expression: "button.type",
                      },
                    },
                    _vm._l(_vm.availableButtonTypes, function (btnType) {
                      return _c(
                        "a-select-option",
                        { key: btnType.value, attrs: { value: btnType.value } },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(btnType.label) +
                              "\n                        "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _vm.templateType === "LIMITED_TIME_OFFER" &&
                  button.type === "URL" &&
                  _vm.isLastUrlButton(button)
                    ? _c(
                        "a-tooltip",
                        {
                          attrs: {
                            title: _vm.$t(
                              "whatsapp_business_api.urlButtonRequiredLto"
                            ),
                          },
                        },
                        [
                          _c(
                            "a-tag",
                            {
                              staticStyle: {
                                margin: "0",
                                "font-size": "10px",
                                padding: "0 4px",
                              },
                              attrs: { color: "red" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "whatsapp_business_api.buttonRequiredTag"
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _vm.isCopyCodeButton(button)
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        flex: "1",
                        display: "flex",
                        "align-items": "center",
                        gap: "8px",
                      },
                    },
                    [
                      _c(
                        "a-tooltip",
                        {
                          attrs: {
                            title: _vm.$t(
                              "whatsapp_business_api.copyCodeButtonFixed"
                            ),
                          },
                        },
                        [
                          _c("a-input", {
                            staticStyle: {
                              flex: "1",
                              "background-color": "#f5f5f5",
                              cursor: "not-allowed",
                            },
                            attrs: {
                              value: _vm.$t("whatsapp_business_api.copyCode"),
                              placeholder: _vm.$t(
                                "whatsapp_business_api.copyCode"
                              ),
                              maxLength: 25,
                              disabled: "",
                              readonly: "",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-tag",
                        {
                          staticStyle: { margin: "0", "font-size": "11px" },
                          attrs: { color: "blue" },
                        },
                        [_vm._v(_vm._s(_vm.$t("whatsapp_business_api.fixed")))]
                      ),
                    ],
                    1
                  )
                : _c("a-input", {
                    staticStyle: { flex: "1" },
                    attrs: {
                      placeholder: _vm.getButtonPlaceholder(button.type),
                      maxLength: 25,
                    },
                    model: {
                      value: button.text,
                      callback: function ($$v) {
                        _vm.$set(button, "text", $$v)
                      },
                      expression: "button.text",
                    },
                  }),
              _vm._v(" "),
              button.type === "URL"
                ? _c("a-input", {
                    staticStyle: { flex: "1" },
                    attrs: {
                      placeholder: "https://example.com/" + "{{" + "1" + "}}",
                    },
                    model: {
                      value: button.url,
                      callback: function ($$v) {
                        _vm.$set(button, "url", $$v)
                      },
                      expression: "button.url",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              button.type === "PHONE_NUMBER"
                ? _c("a-input", {
                    staticStyle: { flex: "1" },
                    attrs: { placeholder: "+1234567890" },
                    model: {
                      value: button.phone_number,
                      callback: function ($$v) {
                        _vm.$set(button, "phone_number", $$v)
                      },
                      expression: "button.phone_number",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              button.type === "COPY_CODE"
                ? _c("a-input", {
                    staticStyle: { flex: "1" },
                    attrs: {
                      placeholder: _vm.$t(
                        "whatsapp_business_api.copyCodeExamplePlaceholder"
                      ),
                    },
                    model: {
                      value: button.example,
                      callback: function ($$v) {
                        _vm.$set(button, "example", $$v)
                      },
                      expression: "button.example",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  style: {
                    visibility: _vm.isButtonRemoveDisabled(button)
                      ? "hidden"
                      : "visible",
                  },
                  attrs: {
                    type: "link",
                    disabled: _vm.isButtonRemoveDisabled(button),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.removeButton(index)
                    },
                  },
                },
                [_c("a-icon", { attrs: { type: "delete" } })],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          button.type === "URL" && _vm.hasDynamicUrl(button.url)
            ? _c("div", { staticClass: "url-example-section" }, [
                _c(
                  "div",
                  { staticClass: "url-example-info" },
                  [
                    _c("a-icon", { attrs: { type: "info-circle" } }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("whatsapp_business_api.dynamicUrlSampleNote")
                        )
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "url-example-input" },
                  [
                    _c("span", {
                      staticClass: "variable-tag",
                      domProps: { textContent: _vm._s("{{1}}") },
                    }),
                    _vm._v(" "),
                    _c("a-input", {
                      staticStyle: { flex: "1" },
                      attrs: {
                        placeholder: _vm.$t(
                          "whatsapp_business_api.exampleValuePlaceholder"
                        ),
                      },
                      model: {
                        value: button.urlExample,
                        callback: function ($$v) {
                          _vm.$set(button, "urlExample", $$v)
                        },
                        expression: "button.urlExample",
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ])
      }),
      0
    ),
    _vm._v(" "),
    _vm.canAddButton
      ? _c(
          "div",
          { staticClass: "add-button-actions" },
          [
            _vm.quickReplyButtons.length > 0
              ? _c(
                  "a-dropdown",
                  { attrs: { trigger: ["click"] } },
                  [
                    _c(
                      "a-button",
                      [
                        _c("a-icon", { attrs: { type: "message" } }),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "whatsapp_business_api.addQuickReplyButton"
                              )
                            ) +
                            " "
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a-menu",
                      { attrs: { slot: "overlay" }, slot: "overlay" },
                      _vm._l(_vm.quickReplyButtons, function (btnType) {
                        return _c(
                          "a-menu-item",
                          {
                            key: btnType.value,
                            on: {
                              click: function ($event) {
                                return _vm.addButton(btnType.value)
                              },
                            },
                          },
                          [
                            _c("a-icon", { attrs: { type: btnType.icon } }),
                            _vm._v(
                              " " + _vm._s(btnType.label) + "\n                "
                            ),
                          ],
                          1
                        )
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.ctaButtons.length > 0
              ? _c(
                  "a-dropdown",
                  { attrs: { trigger: ["click"] } },
                  [
                    _c(
                      "a-button",
                      { attrs: { type: "primary" } },
                      [
                        _c("a-icon", { attrs: { type: "thunderbolt" } }),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("whatsapp_business_api.addCtaButton")
                            ) +
                            " "
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a-menu",
                      { attrs: { slot: "overlay" }, slot: "overlay" },
                      _vm._l(_vm.ctaButtons, function (btnType) {
                        return _c(
                          "a-menu-item",
                          {
                            key: btnType.value,
                            on: {
                              click: function ($event) {
                                return _vm.addButton(btnType.value)
                              },
                            },
                          },
                          [
                            _c("a-icon", { attrs: { type: btnType.icon } }),
                            _vm._v(
                              " " + _vm._s(btnType.label) + "\n                "
                            ),
                          ],
                          1
                        )
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }